export default {
    main: {
        title: '慧乐居-让家居生活更有爱',
        desc: '慧家居,家居产业深度观察者,致力于服务家居建材家装领域的媒体咨询服务和信息化服务平台,打造家居建材产业链共赢平台',
        imgUrl: window.location.origin + '/static/media/share.png',
        link: () => window.location.href
    },
    list: {
        title: '慧乐居-让家居生活更有爱',
        desc: '慧家居,家居产业深度观察者,致力于服务家居建材家装领域的媒体咨询服务和信息化服务平台,打造家居建材产业链共赢平台',
        imgUrl: window.location.origin + '/static/media/share.png',
        link: () => window.location.href
    },
    detail: {
        title: '慧乐居-让家居生活更有爱',
        desc: '',
        imgUrl: window.location.origin + '/static/media/share.png',
        link: () => window.location.href
    }
}


// WEBPACK FOOTER //
// ./src/config/share.config.ts